import React from 'react';
import { render } from 'react-dom';
import './theming/App.scss';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { MainUIProviders } from './components';
import { isDevMode } from './infrastructure/environment';
import { initializeSentry } from './infrastructure/sentryConfiguration';
import { router } from './routes';

initializeSentry();

render(
  <MainUIProviders>
    <RouterProvider router={router} />
  </MainUIProviders>,
  document.getElementById('root')
);

if (isDevMode()) {
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals(console.info);
}
